import React from 'react';
import { Shield, AlertTriangle, CheckCircle2, Info, FileText, Activity, Layers, AlertCircle, TrendingUp, XCircle, Lock, Eye, Database, UserCheck } from 'lucide-react';
import { AppBadge } from '../components/base/AppBadge';
const MONITORED_SYSTEMS = [{
  id: 's1',
  name: 'Customer Assistant',
  type: 'Chatbot',
  risk: 'Limited',
  status: 'Compliant',
  lastAudit: '12 Ott 2023'
}, {
  id: 's2',
  name: 'Resume Screener',
  type: 'HR Tool',
  risk: 'High',
  status: 'Action Required',
  lastAudit: '05 Ott 2023'
}, {
  id: 's3',
  name: 'Spam Filter',
  type: 'Classifier',
  risk: 'Minimal',
  status: 'Compliant',
  lastAudit: '28 Set 2023'
}, {
  id: 's4',
  name: 'Credit Scoring',
  type: 'Finance',
  risk: 'High',
  status: 'Compliant',
  lastAudit: '10 Ott 2023'
}, {
  id: 's5',
  name: 'Deepfake Generator',
  type: 'Media',
  risk: 'Unacceptable',
  status: 'Blocked',
  lastAudit: '01 Ott 2023'
}];
const REQUIREMENTS = [{
  id: 'req1',
  title: 'Data Governance',
  desc: 'Qualità dei dati di addestramento e mitigazione dei bias.',
  status: 'compliant',
  icon: Database
}, {
  id: 'req2',
  title: 'Transparency',
  desc: 'Tracciabilità e documentazione tecnica aggiornata.',
  status: 'compliant',
  icon: Eye
}, {
  id: 'req3',
  title: 'Human Oversight',
  desc: 'Supervisione umana e possibilità di intervento.',
  status: 'warning',
  icon: UserCheck
}, {
  id: 'req4',
  title: 'Cybersecurity',
  desc: 'Robustezza, accuratezza e sicurezza informatica.',
  status: 'compliant',
  icon: Lock
}];
export function AIActPage() {
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-1346">
      {/* Header Section */}
      <div className="mb-8" data-id="element-1347">
        <h1 className="text-[28px] md:text-[32px] font-semibold text-[#2a3a54] tracking-tight" data-id="element-1348">
          AI Act Compliance
        </h1>
      </div>

      {/* Top Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-1349">
        {/* Stat 1 */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm flex flex-col" data-id="element-1350">
          <div className="flex items-center gap-3 mb-4" data-id="element-1351">
            <div className="p-1" data-id="element-1352">
              <Shield className="w-5 h-5 text-gray-400" data-id="element-1353" />
            </div>
            <h3 className="text-[14px] font-medium text-gray-600" data-id="element-1354">
              Compliance Score
            </h3>
          </div>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1355">
            <span className="text-[32px] font-bold text-[#2a3a54]" data-id="element-1356">98%</span>
            <span className="text-[13px] text-emerald-600 font-medium flex items-center gap-1" data-id="element-1357">
              <TrendingUp className="w-3.5 h-3.5" data-id="element-1358" /> +2%
            </span>
          </div>
        </div>

        {/* Stat 2 */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm flex flex-col" data-id="element-1359">
          <div className="flex items-center gap-3 mb-4" data-id="element-1360">
            <div className="p-1" data-id="element-1361">
              <Layers className="w-5 h-5 text-gray-400" data-id="element-1362" />
            </div>
            <h3 className="text-[14px] font-medium text-gray-600" data-id="element-1363">
              Sistemi Monitorati
            </h3>
          </div>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1364">
            <span className="text-[32px] font-bold text-[#2a3a54]" data-id="element-1365">12</span>
            <span className="text-[13px] text-gray-500 font-medium" data-id="element-1366">
              Attivi
            </span>
          </div>
        </div>

        {/* Stat 3 */}
        <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm flex flex-col" data-id="element-1367">
          <div className="flex items-center gap-3 mb-4" data-id="element-1368">
            <div className="p-1" data-id="element-1369">
              <AlertTriangle className="w-5 h-5 text-gray-400" data-id="element-1370" />
            </div>
            <h3 className="text-[14px] font-medium text-gray-600" data-id="element-1371">
              Sistemi ad Alto Rischio
            </h3>
          </div>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1372">
            <span className="text-[32px] font-bold text-[#2a3a54]" data-id="element-1373">2</span>
            <span className="text-[13px] text-amber-600 font-medium flex items-center gap-1" data-id="element-1374">
              <AlertCircle className="w-3.5 h-3.5" data-id="element-1375" /> 1 richiede azione
            </span>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-8" data-id="element-1376">
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-1377">
          <h2 className="text-[16px] font-semibold text-[#2a3a54]" data-id="element-1378">
            Sistemi AI Monitorati
          </h2>
          <button className="text-[13px] text-gray-500 font-medium hover:text-[#2a3a54] transition-colors" data-id="element-1379">
            Esporta Report
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-1380">
          <table className="w-full text-left border-collapse" data-id="element-1381">
            <thead data-id="element-1382">
              <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-1383">
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1384">
                  Sistema
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1385">
                  Tipo
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1386">
                  Livello di Rischio
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1387">
                  Status
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1388">
                  Ultimo Audit
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-1389">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1390">
              {MONITORED_SYSTEMS.map(system => <tr key={system.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-1391">
                  <td className="px-6 py-4" data-id="element-1392">
                    <span className="text-[13px] font-medium text-[#2a3a54]" data-id="element-1393">
                      {system.name}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1394">
                    <span className="text-[13px] text-gray-500" data-id="element-1395">
                      {system.type}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1396">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${system.risk === 'Minimal' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : system.risk === 'Limited' ? 'bg-blue-50 text-blue-700 border-blue-100' : system.risk === 'High' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-1397">
                      {system.risk}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1398">
                    {system.status === 'Compliant' ? <div className="flex items-center gap-1.5 text-emerald-600" data-id="element-1399">
                        <CheckCircle2 className="w-4 h-4" data-id="element-1400" />
                        <span className="text-[13px] font-medium" data-id="element-1401">
                          Conforme
                        </span>
                      </div> : system.status === 'Action Required' ? <div className="flex items-center gap-1.5 text-amber-600" data-id="element-1402">
                        <AlertTriangle className="w-4 h-4" data-id="element-1403" />
                        <span className="text-[13px] font-medium" data-id="element-1404">
                          Azione Richiesta
                        </span>
                      </div> : <div className="flex items-center gap-1.5 text-red-600" data-id="element-1405">
                        <XCircle className="w-4 h-4" data-id="element-1406" />
                        <span className="text-[13px] font-medium" data-id="element-1407">
                          Bloccato
                        </span>
                      </div>}
                  </td>
                  <td className="px-6 py-4" data-id="element-1408">
                    <span className="text-[13px] text-gray-500" data-id="element-1409">
                      {system.lastAudit}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-1410">
                    <button className="text-[13px] font-medium text-[#00B4D8] hover:text-[#0096b4] transition-colors" data-id="element-1411">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {/* Main Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1412">
        {/* Left Column: Risk Classification */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col" data-id="element-1413">
          <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-1414">
            <h2 className="text-[16px] font-semibold text-[#2a3a54] flex items-center gap-2" data-id="element-1415">
              <Activity className="w-4 h-4 text-[#00B4D8]" data-id="element-1416" />
              Classificazione del Rischio
            </h2>
            <button className="text-[13px] text-[#00B4D8] font-medium hover:underline" data-id="element-1417">
              Vedi Linee Guida
            </button>
          </div>
          <div className="p-6 flex-1 flex flex-col gap-4" data-id="element-1418">
            {/* Unacceptable Risk */}
            <div className="flex items-start gap-4 p-4 rounded-lg bg-red-50 border border-red-100" data-id="element-1419">
              <div className="mt-0.5" data-id="element-1420">
                <XCircle className="w-4 h-4 text-gray-400" data-id="element-1421" />
              </div>
              <div className="flex-1" data-id="element-1422">
                <div className="flex items-center justify-between mb-1" data-id="element-1423">
                  <h4 className="text-[14px] font-semibold text-red-900" data-id="element-1424">
                    Rischio Inaccettabile
                  </h4>
                  <span className="text-[12px] font-bold text-red-700 bg-red-100 px-2 py-0.5 rounded-full" data-id="element-1425">
                    1
                  </span>
                </div>
                <p className="text-[12px] text-red-700/80 leading-relaxed" data-id="element-1426">
                  Sistemi vietati (es. social scoring, manipolazione
                  subliminale).
                </p>
              </div>
            </div>

            {/* High Risk */}
            <div className="flex items-start gap-4 p-4 rounded-lg bg-amber-50 border border-amber-100" data-id="element-1427">
              <div className="mt-0.5" data-id="element-1428">
                <AlertTriangle className="w-4 h-4 text-gray-400" data-id="element-1429" />
              </div>
              <div className="flex-1" data-id="element-1430">
                <div className="flex items-center justify-between mb-1" data-id="element-1431">
                  <h4 className="text-[14px] font-semibold text-amber-900" data-id="element-1432">
                    Alto Rischio
                  </h4>
                  <span className="text-[12px] font-bold text-amber-700 bg-amber-100 px-2 py-0.5 rounded-full" data-id="element-1433">
                    2
                  </span>
                </div>
                <p className="text-[12px] text-amber-700/80 leading-relaxed" data-id="element-1434">
                  Requisiti rigorosi: data governance, documentazione,
                  supervisione umana.
                </p>
              </div>
            </div>

            {/* Limited Risk */}
            <div className="flex items-start gap-4 p-4 rounded-lg bg-blue-50 border border-blue-100" data-id="element-1435">
              <div className="mt-0.5" data-id="element-1436">
                <Info className="w-4 h-4 text-gray-400" data-id="element-1437" />
              </div>
              <div className="flex-1" data-id="element-1438">
                <div className="flex items-center justify-between mb-1" data-id="element-1439">
                  <h4 className="text-[14px] font-semibold text-blue-900" data-id="element-1440">
                    Rischio Limitato
                  </h4>
                  <span className="text-[12px] font-bold text-blue-700 bg-blue-100 px-2 py-0.5 rounded-full" data-id="element-1441">
                    4
                  </span>
                </div>
                <p className="text-[12px] text-blue-700/80 leading-relaxed" data-id="element-1442">
                  Obblighi di trasparenza (es. chatbot devono dichiarare di
                  essere AI).
                </p>
              </div>
            </div>

            {/* Minimal Risk */}
            <div className="flex items-start gap-4 p-4 rounded-lg bg-emerald-50 border border-emerald-100" data-id="element-1443">
              <div className="mt-0.5" data-id="element-1444">
                <CheckCircle2 className="w-4 h-4 text-gray-400" data-id="element-1445" />
              </div>
              <div className="flex-1" data-id="element-1446">
                <div className="flex items-center justify-between mb-1" data-id="element-1447">
                  <h4 className="text-[14px] font-semibold text-emerald-900" data-id="element-1448">
                    Rischio Minimo
                  </h4>
                  <span className="text-[12px] font-bold text-emerald-700 bg-emerald-100 px-2 py-0.5 rounded-full" data-id="element-1449">
                    5
                  </span>
                </div>
                <p className="text-[12px] text-emerald-700/80 leading-relaxed" data-id="element-1450">
                  Nessun obbligo specifico, incoraggiati codici di condotta
                  volontari.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Key Requirements Checklist */}
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden flex flex-col" data-id="element-1451">
          <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-1452">
            <h2 className="text-[16px] font-semibold text-[#2a3a54] flex items-center gap-2" data-id="element-1453">
              <FileText className="w-4 h-4 text-[#00B4D8]" data-id="element-1454" />
              Requisiti Chiave (Alto Rischio)
            </h2>
          </div>
          <div className="p-6 flex-1 flex flex-col gap-4" data-id="element-1455">
            {REQUIREMENTS.map(req => <div key={req.id} className="flex items-center gap-4 p-4 rounded-lg border border-gray-100 bg-gray-50/50" data-id="element-1456">
                <div className="text-gray-400" data-id="element-1457">
                  <req.icon className="w-5 h-5" data-id="element-1458" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-1459">
                  <h4 className="text-[14px] font-medium text-[#2a3a54] mb-0.5" data-id="element-1460">
                    {req.title}
                  </h4>
                  <p className="text-[12px] text-gray-500 truncate" data-id="element-1461">
                    {req.desc}
                  </p>
                </div>
                <div className="flex-shrink-0" data-id="element-1462">
                  {req.status === 'compliant' ? <AppBadge variant="default" className="bg-emerald-50 text-emerald-600 border border-emerald-100" data-id="element-1463">
                      Conforme
                    </AppBadge> : <AppBadge variant="default" className="bg-amber-50 text-amber-600 border border-amber-100" data-id="element-1464">
                      In revisione
                    </AppBadge>}
                </div>
              </div>)}

            <div className="mt-auto pt-4" data-id="element-1465">
              <button className="w-full py-2.5 bg-white border border-gray-200 text-[#2a3a54] text-[13px] font-medium rounded-lg hover:bg-gray-50 transition-colors shadow-sm" data-id="element-1466">
                Esegui Audit Completo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
}